import { map } from 'rxjs/operators';
import { Component, OnInit, Input, EventEmitter, OnDestroy, ViewChild,HostListener, AfterContentInit } from '@angular/core';
import { FormGroup, FormControl, NgForm, AbstractControl }   from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';

import { UsersService, UserModel, initUserModel, UserProfileService, UTF8  } from '../../../../../core';
import { UsersStateService } from './users-state.service';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';

@Component({
  selector: 'app-add-edit-user',
  templateUrl: './add-edit-user.component.html',
  styleUrls: ['./add-edit-user.component.scss']
})

export class AddEditUserComponent implements OnInit, OnDestroy {
@ViewChild('userForm', { static: true }) userForm:NgForm;
highlightInvalidEntries:boolean;
enablePasswordMatching:boolean = false;
userID:string;
customerID:number;
userLinked: boolean ;
UserList: Array<{ PotralUserid: number, UserName: string, FirstName: string, LastName: string, EmailAddress: string, isTest: boolean }> = [];
isBusy:boolean;
user:UserModel;
userNameOrNew:string ;

accessLevelDropdownPopupSettings:PopupSettings={};
accessList:{id:number, desc:string}[]=[];

passwordString:string;
confirmPassword:string;
isSuperUser:boolean;
subscriptions:Subscription[]=[];

  constructor(
    private usersService:UsersService
    ,private usersStateService: UsersStateService
    ,private userProfileService:UserProfileService

  ) { 
    this.isSuperUser = this.userProfileService.data.RoleList.includes("Super User");
    if (this.isSuperUser) {
      this.accessList = [{id:1, desc:"Super User"},{id:2, desc:"Corporate Admin"},{id:3, desc:"Registered User"}] ;
    }else if(this.userProfileService.data.RoleList.includes("Corporate Admin")){
      this.accessList = [{id:2, desc:"Corporate Admin"},{id:3, desc:"Registered User"}] ;
    }else{
      this.accessList = [{id:3, desc:"Registered User"}] ;
    }
  }
  ngOnInit() {
    this.UserList =[
      {PotralUserid : null,EmailAddress: '',FirstName: '',LastName:'',UserName:null,isTest:true},
    ];
    this.reset();
    
  }
  ngOnDestroy(){
    this.userIsInit = false;
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  userIsInit:boolean = false;
  loadedUserName:string = null;
  ngAfterContentInit() {
    this.userIsInit = false;
  }

  loadUser(id:string,  customerID:number){
    this.userID = id ;
    this.customerID = customerID;
    this.passwordString="";
    this.confirmPassword="";
    this.userNameOrNew = "Manage User Link";
    if(id !== '') {
      this.isBusy = true;
      this.userLinked = true;
      this.usersService.securityGetUserByUserID(id)
        .subscribe(
          user => {
            this.user = user;
            this.loadedUserName = user.UserName;
            this.userIsInit = true;
            this.userNameOrNew = user.FirstName + " " + user.LastName;
            this.passwordString = "";
          }
          , (err) => { this.isBusy = false; this.confirmDlg("Request Failed", null, "Failed", false); console.log(err); },
          () => this.isBusy = false
        );
    }else{
      this.reset();
      this.userIsInit = true;
    }
  }
  loadUserDopdown(customerId:number|null) {
    this.userID ='';
    this.isBusy = true;
    this.customerID=customerId;
    this.userLinked=false;
    this.userNameOrNew = "Manage User Link";
    this.usersService.getCustomerUserList('',customerId).subscribe(data => {
      this.UserList = [
        { FirstName: '', PotralUserid: null, LastName: '', UserName: "(Please Select User)", EmailAddress: "", isTest: true }
      ];
      if(data == null){
        this.isBusy = false; 
        this.confirmDlg("This customer is not yet linked to an account.", "Please contact support to have this completed.", "RequestFail", false); 
        return;
      }
      var adding = data.map(item => {
        return {
          FirstName: item.FirstName,
          PotralUserid: item.UserId,
          LastName: item.LastName,
          UserName: item.UserName,
          EmailAddress: item.EmailAddress
        };
      }
      ).sort((a, b) => {
        return a.UserName.toLowerCase().localeCompare(b.UserName.toLowerCase());
      })
      this.UserList = this.UserList.concat(adding);
      if (this.UserList != null) {
        if (!this.userLinked) {
          this.user.FirstName = this.UserList[0].FirstName;
          this.user.PotralUserid = this.UserList[0].PotralUserid;
          this.user.LastName = this.UserList[0].LastName;
          this.user.UserName = this.UserList[0].UserName;
          this.user.EMailAddress=this.UserList[0].EmailAddress;
        }
      }
    }, (err) => { this.isBusy = false; this.confirmDlg("Request Failed", "Failed","RequestFail", false); console.log(err); },

    () => this.isBusy = false);

  }
  linkedUser_selectionChange(value: any) {
   
    this.user = initUserModel();
    this.user.FirstName = value.FirstName;
    this.user.PotralUserid =value.PotralUserid;
    this.user.LastName = value.LastName;
    this.user.UserName = value.UserName;
    this.user.EMailAddress=value.EmailAddress;
}
    reset(){
    this.user = initUserModel();
    this.userIsInit = false;
    this.loadedUserName = null;
    this.highlightInvalidEntries = false;
    this.userNameOrNew = "Manage User Link";
    this.enablePasswordMatching = false;
    this.UserList=[];
  }
  testValidPullClass(inp:any){
    let ctrl:AbstractControl = inp as AbstractControl;
    return (ctrl.invalid && (this.highlightInvalidEntries))?'flagInvalid':'';
  }
   validateEntries(){
    if( this.userForm.invalid
        || (this.user.FirstName === '')
        || (this.user.LastName ==='')
        || (this.user.UserName === '' || this.user.UserName.trim().toLowerCase() === "(please select user)" )
      ){
      this.highlightInvalidEntries=true;
      return false;
    }
    return true;
  }

  onSaveUser(){

  this.IssecurityIsUserNameValid2()
  .then(result => {
    if (result) {
      if (!this.validateEntries()){
        this.confirmDlg("Please Select User / Enter User Name ",null, "Failed", false);
        return;
      }
     
        this.isBusy = true;
        let saving = {...this.user};
    if(saving.UserID == ''){
      saving.UserID = '00000000-0000-0000-0000-000000000000';
    }
    this.usersService.securitySaveUser(saving, this.customerID)
    .subscribe(
      okay => {
        if (okay) {
          this.usersStateService.updateUserList(this.user);
          this.confirmDlgMacro( ()=>this.confirmDlg('User Saved Successfully', null,'Save Complete', false), (okay)=>this.exit());
        }else{
          this.confirmDlgMacro( ()=>this.confirmDlg("User was not saved",null, "Failed", false),()=>{});
        }
      }
      ,(err)=>{this.isBusy = false; this.confirmDlg("Error Linking User",null, "Failed", false); console.log(err);},
      () => this.isBusy = false
    );
    } else {
      this.confirmDlgMacro(() => this.confirmDlg(
        'User Name ' + this.user.UserName + ' is already in use.  Please select another user name for this individual.',
        'Invalid User Name','',false),  () => {this.user.UserName = this.loadedUserName; });
    }
  })
  .catch((error: any) => {
    this.isBusy = false; 
    this.confirmDlg("Error Linking User",null, "Failed", false); console.log(error);
  }); 
  }

  get showPasswordsDidNotMatch():boolean{
    if(this.enablePasswordMatching){
      if(this.passwordString != "" && this.confirmPassword !=""){
        return this.passwordString !== this.confirmPassword;
      }
    }
    return false;
  }
  startPasswordMatch(){
    this.enablePasswordMatching = true;
  }
  onCancel(){
    this.confirmDlgMacro(
      ()=>this.confirmDlg("Are you sure you wish to cancel edit on this user."
    ,"Any unsaved changes will be lost.", "Confirmation", true)
    ,(okay) => {
          if(okay){
            this.exit();
          }
        }
      );
  }
  exit(){
    this.userIsInit = false;
    this.usersStateService.hideAddEditDialog();
    this.userForm.resetForm();

  }
  confirmDlgMacro(dlgCall:()=>Observable<boolean>, completeCall:(okay:boolean)=>void){
    this.subscriptions.push(
      dlgCall()
      .subscribe(
        (okay) => completeCall(okay)
      )
    );
  }
    openModal:boolean=false;
    dialogTitle:string ="";
    dialogTextLine1:string = "";
    dialogTextLine2:string = '';
    cancelButton:string = null;
    onDialogDone:Subject<boolean> = null;
    okCloseButtonClick(ok:boolean){
      if (this.onDialogDone ) {
        this.openModal = false;
        this.onDialogDone.next(ok);
      }
    }
    confirmDlg(msg:string , msg2:string , title:string, cancelButton:boolean = false ):Observable<boolean>{
      this.dialogTitle = title;
      this.dialogTextLine1 = msg;
      this.dialogTextLine2 = msg2;
      this.openModal = true;
      this.onDialogDone = new Subject<boolean>();

      this.cancelButton = cancelButton?"Cancel":null;
      return this.onDialogDone.asObservable();
    }

  /*
      InvalidDisplayMessage = "Fist Name is required",
      InvalidDisplayMessage = "Last Name is required",
      InvalidDisplayMessage = "Email is not in correct format",
      InvalidDisplayMessage = "Login name is required",
      InvalidDisplayMessage = "Security Question is required",
      InvalidDisplayMessage = "Security Answer is required",
    */
		onBlurUserName(event)
		{
      // Veify the UserName is not used
      if(!this.userIsInit )
        return;
      let userName = this.user.UserName;
      if(this.loadedUserName!=null && userName == this.loadedUserName)
        return;
      
      this.usersService.securityIsUserNameAvailable(userName).
      subscribe(
        (okeyDokey) => {
          if (!okeyDokey) {
            this.confirmDlgMacro(() => this.confirmDlg(
              'User Name ' + userName + ' is already in use.  Please select another user name for this individual.',
              'Invalid User Name','',false),  () => {this.user.UserName = this.loadedUserName; });
          }
        }
        , (err) => { this.isBusy = false; this.confirmDlg("Request Failed", null, "Failed", false); console.log(err); }
        ,()=>this.isBusy = false
      );
    }

    IssecurityIsUserNameValid2(): Promise<boolean> {
      return new Promise<boolean>((resolve, reject) => {
       
        let validation = true;
        let userName = this.user.UserName;
        if(this.loadedUserName!=null && userName == this.loadedUserName)
            resolve(true); 
            this.isBusy = true;
            this.usersService.securityIsUserNameAvailable(userName).toPromise().then(okeyDokey => {
            this.isBusy = false;
            if (!okeyDokey) {
              return  resolve(false); // Returning false if the username is not available.
              } else {
              return  resolve(true); // Returning true if the username is available.
            }
          }).catch(error => {
              this.isBusy = false; 
                this.confirmDlg("Request Failed", null, "Failed", false); 
                console.log(error);
            return reject(error);
          });
      });
    }
} 
